import React, { useState } from "react";
import "./BugSeverityAnalyzer.css";

function BugSeverityAnalyzer() {
  const [bug, setBug] = useState("");
  const [result, setResult] = useState("");
  const [loading, setLoading] = useState(false);

  const analyzeBug = async () => {
    if (!bug.trim()) {
      alert("Please enter a bug description.");
      return;
    }

    setLoading(true);
    setResult("");

    try {
      const response = await fetch(
        "https://qa-ai-platform-backend.onrender.com/api/bug-severity",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ bug }),
        }
      );

      const data = await response.json();
      setResult(data.analysis || "No analysis returned.");
    } catch (error) {
      console.error(error);
      setResult("Failed to analyze bug.");
    }

    setLoading(false);
  };

  return (
    <div className="bs-container">
      <h1>🐞 Bug Severity Analyzer</h1>

      <textarea
        className="bs-input"
        placeholder="Example: Login button does nothing on Safari after clicking submit"
        value={bug}
        onChange={(e) => setBug(e.target.value)}
      />

      <button className="bs-btn" onClick={analyzeBug} disabled={loading}>
        {loading ? "Analyzing..." : "Analyze Bug"}
      </button>

      {result && (
        <div className="bs-output">
          <h3>AI Analysis:</h3>
          <pre>{result}</pre>
        </div>
      )}
    </div>
  );
}

export default BugSeverityAnalyzer;
